var Query = /** @class */ (function () {
    function Query(provider) {
        this.provider = provider;
    }
    Query.prototype.getBlockByNumber = function (blockNumber, fullTransaction) {
        return this.sendAsync('eth_getBlockByNumber', blockNumber, fullTransaction);
    };
    Query.prototype.getCode = function (address, blockNumber) {
        if (blockNumber === void 0) { blockNumber = 'latest'; }
        return this.sendAsync('eth_getCode', address, blockNumber);
    };
    Query.prototype.estimateGas = function (txParams) {
        return this.sendAsync('eth_estimateGas', txParams);
    };
    Query.prototype.sendAsync = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            _this.provider.sendAsync({
                id: 42,
                jsonrpc: '2.0',
                method: methodName,
                params: args,
            }, function (error, response) {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(response.result);
                }
            });
        });
    };
    return Query;
}());
export { Query };
//# sourceMappingURL=query.js.map